// שיוך מתמיד של תיק מנוהל ללקוח: "<house>_<portfolioNum>" → { clientId, clientName }.
// נשמר כדי שהעלאה חודשית חוזרת של אותו תיק תשויך אוטומטית בלי אישור מחדש.
// מפתח רשום ב-storage.js STORAGE_KEYS → IndexedDB + סנכרון ענן.

import { memoryStore } from "./storage";

const KEY = "pension_portfolio_map_v1";

function read() {
  try {
    const raw = memoryStore.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function write(obj) {
  try {
    memoryStore.setItem(KEY, JSON.stringify(obj));
  } catch (e) {
    console.error("Failed to persist portfolio-client map", e);
  }
}

export function portfolioKey(house, portfolioNum) {
  return `${house}_${portfolioNum}`;
}

export function getPortfolioMapping(house, portfolioNum) {
  return read()[portfolioKey(house, portfolioNum)] || null;
}

// entries: [{ house, portfolioNum, clientId, clientName }]
export function savePortfolioMappings(entries) {
  if (!entries?.length) return;
  const all = read();
  for (const e of entries) {
    all[portfolioKey(e.house, e.portfolioNum)] = {
      clientId: e.clientId,
      clientName: e.clientName,
      updatedAt: new Date().toISOString(),
    };
  }
  write(all);
}

export function removePortfolioMapping(house, portfolioNum) {
  const all = read();
  const k = portfolioKey(house, portfolioNum);
  if (all[k]) {
    delete all[k];
    write(all);
  }
}
